/* LUZ NOVA — slide-out cart drawer.
   Kept separate from global.js on purpose: this feature can be reviewed and
   reverted independently, and the 56KB core file stays untouched apart from
   the one-line hook in the Add to bag handler (see global.js). */
(function () {
  "use strict";

  var root = document.getElementById("CartDrawer");
  if (!root) return;

  var body = root.querySelector("[data-cart-drawer-body]");
  var countEl = root.querySelector("[data-cart-drawer-count]");
  var subtotalEl = root.querySelector("[data-cart-drawer-subtotal]");
  var overlay = root.querySelector(".cart-drawer__overlay");

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function" && window.LuzMoneyFormat) {
      try { return Shopify.formatMoney(cents, window.LuzMoneyFormat); } catch (e) { /* fall through */ }
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function lineRow(item) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x120_crop_center$1") : "";
    return (
      '<div class="cart-row cart-drawer__row" data-line-key="' + item.key + '">' +
        '<div class="cart-row__media">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="90" height="90">' : "") +
        "</div>" +
        '<div class="cart-drawer__row-meta">' +
          "<strong>" + item.product_title + "</strong>" +
          (item.variant_title ? '<div class="cart-row__meta">' + item.variant_title + "</div>" : "") +
          '<div class="qty cart-drawer__qty">' +
            '<button type="button" data-drawer-qty-change="-1" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
            '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
            '<button type="button" data-drawer-qty-change="1" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          "</div>" +
        "</div>" +
        '<div class="cart-drawer__row-price">' + money(item.final_line_price) + "</div>" +
      "</div>"
    );
  }

  function render(cart) {
    if (!cart) return;
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      return;
    }
    body.innerHTML = cart.items.map(lineRow).join("");
  }

  async function fetchCart() {
    try {
      var res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function refresh() {
    var cart = await fetchCart();
    render(cart);
    return cart;
  }

  function open() {
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () { root.classList.add("is-open"); });
  }

  function close() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(function () { root.hidden = true; }, 260);
  }

  document.querySelectorAll("[data-cart-drawer-open]").forEach(function (el) {
    el.addEventListener("click", function (evt) {
      evt.preventDefault();
      refresh();
      open();
    });
  });
  root.querySelectorAll("[data-cart-drawer-close]").forEach(function (btn) {
    btn.addEventListener("click", close);
  });
  document.addEventListener("keydown", function (evt) {
    if (evt.key === "Escape" && root.classList.contains("is-open")) close();
  });

  body && body.addEventListener("click", async function (evt) {
    var btn = evt.target.closest("[data-drawer-qty-change]");
    if (!btn) return;
    var row = btn.closest("[data-line-key]");
    var input = row && row.querySelector("input");
    var current = input ? Number(input.value) : 0;
    var next = Math.max(0, current + Number(btn.dataset.drawerQtyChange));
    btn.disabled = true;
    try {
      var res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: btn.dataset.key, quantity: next }),
      });
      var cart = await res.json();
      render(cart);
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) { el.removeAttribute("data-zero"); }
        else { el.setAttribute("data-zero", ""); }
      });
    } catch (e) {
      /* leave the row as-is; the standalone cart page is still correct */
    } finally {
      btn.disabled = false;
    }
  });

  /* Exposed so global.js's Add to bag handler can open the drawer with the
     cart payload it already fetched, instead of a second round trip. */
  window.LuzCartDrawer = {
    open: function (cart) { if (cart) render(cart); else refresh(); open(); },
    close: close,
    refresh: refresh
  };
})();
